
import type { Action } from '@empathybroker/tsclient-play/dist/models/action'
import type { CurationTool } from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { CrudActionEnum, DeviceEnum } from '../../enums'
import { UiTooltip } from '../keen-ui'
import { EpbButton } from '../shared/epb-button'
import SearchBox from '../shared/search-box.component.vue'

export default defineComponent({
  name: 'ActionsBar',
  components: {
    EpbButton,
    SearchBox,
    UiTooltip,
  },
  props: {
    searchBoxAvailable: Boolean,
    strictMatching: Boolean,
    query: String,
    selection: Array as PropType<Array<Action>>,
    permissions: Array as PropType<Array<string>>,
    enableActionsAvailable: Boolean,
    bulkEditActionAvailable: Boolean,
    forceNoDuplicatedItems: Boolean,
    forceOnlyOneItemEnabled: Boolean,
    forceOnlyOneItemEditable: Boolean,
    strictMatchingAvailable: Boolean,
  },
  data() {
    return {
      CrudActionEnum,
      DeviceEnum,
    }
  },
  computed: {
    deleteActionDisabled(): boolean {
      return (
        !this.selection.length ||
        (this.forceOnlyOneItemEnabled &&
          this.selection.some((selectedItem: any) => this.isEnabled(selectedItem)))
      )
    },
    enableActionDisabled(): boolean {
      const duplicated: boolean =
        this.forceNoDuplicatedItems &&
        this.selection.reduce(
          (duplicated: { found: boolean; list: string[] }, selectedItem: CurationTool) => {
            if (!selectedItem.criteria || duplicated.found) {
              return duplicated
            }
            const key = this.getSelectionDuplicateKey(selectedItem)
            const found = duplicated.list.includes(key)

            return {
              found,
              list: [...duplicated.list, key],
            }
          },
          {
            found: false,
            list: [],
          },
        ).found

      return (
        duplicated ||
        (this.forceOnlyOneItemEnabled && this.selection.length > 1) ||
        this.selection.every((selectedItem: any) => this.isEnabled(selectedItem))
      )
    },
    disableActionDisabled(): boolean {
      return this.selection.every((selectedItem: any) => !this.isEnabled(selectedItem))
    },
    enableActionAllowed(): boolean {
      return this.hasPermission(CrudActionEnum.UPDATE) && this.enableActionsAvailable
    },
    bulkEditActionAllowed(): boolean {
      return this.hasPermission(CrudActionEnum.UPDATE) && this.bulkEditActionAvailable
    },
  },
  methods: {
    onQueryChange(newValue: string): void {
      this.$emit('queryChange', newValue)
    },
    hasPermission(action: CrudActionEnum): boolean {
      return this.permissions.includes(action)
    },
    isEnabled(selectedItem: any): boolean {
      return selectedItem.criteria ? selectedItem.criteria.enabled : selectedItem.enabled
    },
    getSelectionDuplicateKey(selectedItem: any): string {
      const criteria = selectedItem.criteria ?? {}
      return JSON.stringify({
        endpointId: selectedItem.endpointId,
        query: criteria.queries?.[0],
        context: criteria.context,
        pivots: criteria.pivots,
      })
    },
  },
})
